export default __webpack_public_path__ + "static/media/branding-medium-webfont.94bba7c6.woff";